var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2583 3.92798H14.4342C10.2749 3.92798 6.89673 7.32569 6.89673 11.4654V38.9791C6.89673 42.4939 9.41572 43.978 12.501 42.2791L22.0302 36.9873C23.0456 36.421 24.6859 36.421 25.6818 36.9873L35.211 42.2791C38.2962 43.9975 40.8152 42.5135 40.8152 38.9791V11.4654C40.7957 7.32569 37.4175 3.92798 33.2583 3.92798Z",
    stroke: "white",
    strokeWidth: 2.92906,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.139 21.5024L22.0683 24.4316L29.8795 16.6204",
    stroke: "white",
    strokeWidth: 2.92906,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.03fac5c76bcf4c1f1d379f33e6e1cecd.svg";
export { ForwardRef as ReactComponent };